import res from './res'

res.add('en', {
    selectionOptions: {
        all: 'Select all',
        none: 'Clear',
        invert: 'Invert selection'
    }
})
